<template>
    <div v-if="display" class="text-center small">
        {{t('title', {email: email})}}
    </div>
</template>

<script>
    import Panel from "@/components/Panel.vue";

    export default {
        name: "ApprovalsManager",
        components: {
            Panel
        },
        data() {

            return {
                t_path: "components.approvals.manager",
            }
        },
        computed: {
            email() {

                return this.$store.getters["user/approvalManagerEmail"];
            },
            display() {

                return 1 == process.env.VUE_APP_ENABLED_APPROVAL_DISPLAY_USER_MANAGER && this.email
            }
        },
    }
</script>

<style scoped lang="scss">

</style>